import styled from "styled-components";
import { getHeading3BoldTypography } from "../../Typography";
import { getParagraph16RegularTypography } from "../../Typography/Paragraph16";

export const TrackTitle = styled.p`
  ${getHeading3BoldTypography};
  color: ${({ theme }) => theme.primaryColor};
  font-size: 40px;
  padding-bottom: 16px;
  line-height: 48px;
`;

export const TrackSubtitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 32px;
`;

export const TrackSubtitle = styled.div`
  ${getParagraph16RegularTypography};
  color: ${({ theme }) => theme.primaryColor};
  line-height: 19px;
  opacity: 0.7;
  font-weight: 500;
`;
